import { render, staticRenderFns } from "./datatable-detail.vue?vue&type=template&id=7e935fd2&scoped=true&"
import script from "./datatable-detail.vue?vue&type=script&lang=js&"
export * from "./datatable-detail.vue?vue&type=script&lang=js&"
import style0 from "./datatable-detail.vue?vue&type=style&index=0&id=7e935fd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e935fd2",
  null
  
)

export default component.exports